module.exports = __webpack_public_path__ + "img/card-profile-default-banner.165bd660.png";